import React, { useState } from 'react';
import './SearchBar.css';
import { usePostHog } from 'posthog-js/react'

export function SearchBar({ query, setQuery }) {
  const posthog = usePostHog();
  const [inputValue, setInputValue] = useState(query);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      posthog.capture('search_enter_pressed', { value: inputValue })
      setQuery(inputValue);
    }
  };

  const handleChange = (e) => {
    posthog.capture('search_input_changed', { value: e.target.value })
    setInputValue(e.target.value);
  };

  return (
    <div className="searchBarContainer">
        <div className="searchBarExpanded">
          <input
            className="searchInput"
            type="text"
            placeholder="Search"
            value={inputValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </div>
    </div>
  );
}
